import "./Login.css"; // reuse the centering styles
import TwoFactorForm from "../components/forms/TwoFactorForm";
import { useMessages } from "../context/MessageContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { resendTwoFactorCode, verifyTwoFactorCode } from "../api/auth";

function TwoFAPage(){
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { addMessage } = useMessages();
    const { login: establishSession } = useAuth();
    const resolveTarget = () => {
      const nextParam = searchParams.get("next");
      if (nextParam && nextParam.startsWith("/") && nextParam !== "/2fa") {
        return nextParam;
      }
      return "/blog";
    };

    const handleLogin = async (code) => {
      try {
          const token = sessionStorage.getItem("two_factor_token");
          if (!token) {
              addMessage("error", "2FA sessie verlopen. Log opnieuw in.");
              navigate("/login", { replace: true });
              return;
          }
          const { access, refresh } = await verifyTwoFactorCode(token, code);
          establishSession(access, refresh);
          sessionStorage.removeItem("two_factor_token");
          sessionStorage.removeItem("two_factor_username");
          addMessage("success", "Welkom terug!");
          navigate(resolveTarget(), { replace: true });
      } catch (error) {
          addMessage("error", "Verificatie mislukt. Controleer de code.");
      }
  };

  const handleResend = async () => {
      try {
          const token = sessionStorage.getItem("two_factor_token");
          if (!token) {
              addMessage("error", "2FA sessie verlopen. Log opnieuw in.");
              navigate("/login", { replace: true });
              return;
          }
          const { two_factor_token: newToken } = await resendTwoFactorCode(token);
          sessionStorage.setItem("two_factor_token", newToken);
          addMessage("success", "Nieuwe code is verzonden.");
      } catch (error) {
          addMessage("error", "Opnieuw verzenden mislukt.");
      }
  };

  return (
    <div className="auth-page reset-page">
      <div className="reset-container">
        <TwoFactorForm onSubmit={handleLogin} onResend={handleResend}/>
      </div>
    </div>
  );
}

export default TwoFAPage;
